import React from 'react';
interface LogoProps {
  variant?: 'full' | 'wordmark' | 'mark';
  className?: string;
  markClassName?: string;
}
export function Logo({
  variant = 'full',
  className = '',
  markClassName = ''
}: LogoProps) {
  return <span className={`inline-flex items-center gap-3 ${className}`} data-id="element-28" data-mp="1mp9ji4lzzb24">
      {variant !== 'wordmark' && <Mark className={markClassName} data-id="element-29" data-mp="1rm9qqiul2jut" />}
      {variant !== 'mark' && <span className="font-serif text-[1.35em] leading-none tracking-wordmark" data-id="element-30" data-mp="tzswjmh5cmda">REPUBLIC</span>}
      <span className="sr-only" data-id="element-31" data-mp="yy457tvpgqtx">Republic</span>
    </span>;
}
export function Mark({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" className={`h-[1.1em] w-[1.1em] shrink-0 ${className}`} fill="none" data-id="element-32" data-mp="13w5oofx1ms5x">
      <circle cx="12" cy="12" r="9.4" stroke="currentColor" strokeWidth="1.6" strokeDasharray="25.5 4 25.5 4" transform="rotate(-42 12 12)" data-id="element-33" data-mp="2fd5n7t9zi38e" />
    </svg>;
}